import { ROUTE_PATH_ACTIVATE,URL_INTX_LOGIN_PAGE_FR_CA } from '../../constants';
import { ScamDetectionPageTranslations } from '../types';

export const translations: ScamDetectionPageTranslations = {
  docTitle: 'Détection des fraudes',
  pageTitle: 'Détection des fraudes',
  featureList: [
    {
      // 'key' MUST BE the same as array index
      key: '0',
      heading: 'Gardez une longueur d&#39avance sur les fraudeurs grâce à la détection alimentée par l&#39IA',
      summary: [
        '<p>Dans le monde numérique d&#39aujourd&#39hui, les fraudeurs utilisent des tactiques de plus en plus sophistiquées pour voler vos renseignements personnels. Avec Analyse & Évaluation, vous pouvez instantanément analyser les courriels, textos et liens suspects pour détecter les arnaques potentielles avant qu&#39elles ne causent des dommages. Cette approche proactive vous aide à prendre des décisions éclairées et à éviter de devenir victime d&#39arnaques de plus en plus sophistiquées. De plus, avec Auto-Analyse, vous pouvez configurer une surveillance automatique des courriels, permettant à Analyse & Évaluation d&#39identifier de manière proactive les menaces potentielles dans votre boîte de réception. Cette couche de protection supplémentaire fonctionne jour et nuit pour vous protéger des dernières tentatives de fraude.</p>',
        '<h2 class="feature-item-heading">Analyse alimentée par l&#39IA</h2>',
        '<p>Soumettez toute communication suspecte via notre site Web ou application mobile et recevez une évaluation instantanée. Analyse & Évaluation analyse le contenu et vous fournit un Score d&#39arnaque clair indiquant le niveau de risque, vous aidant à identifier les menaces potentielles avant qu&#39elles ne puissent causer des dommages.</p>',
        '<br>' 
      ].join('\n')
    },
    {
      key: '1',
      heading: '',
      summary: [
        '<h2 class="feature-item-heading">Évaluation intelligente des risques</h2>',
        '<p>Chaque soumission reçoit une évaluation complète qui analyse plusieurs aspects de la communication pour déterminer sa légitimité. Vous recevrez une notation claire du Score d&#39arnaque (Risque faible, Niveau de risque non concluant, ou Risque élevé) ainsi que des facteurs contributifs détaillés qui expliquent pourquoi la communication peut être digne de confiance ou non.</p>',
        '<h2 class="feature-item-heading">Recommandations concrètes</h2>',
        '<p>En fonction des résultats de votre Score d&#39arnaque, vous recevrez des recommandations spécifiques sur la façon de vous protéger. Ces étapes pratiques vous aident à prendre des décisions éclairées sur la gestion des communications suspectes et à protéger vos renseignements personnels contre les menaces potentielles.</p>',
        '<h2 class="feature-item-heading">Détection des fraudes sur mobile</h2>',
        '<p>Accédez à Analyse & Évaluation à tout moment et n&#39importe où grâce à notre application mobile. Cela vous permet de vérifier les messages suspects dès que vous les recevez, offrant une tranquillité d&#39esprit immédiate où que vous soyez.</p>'

      ].join('\n')
      ,
      action: {
        login: {
          to: '',
          href: URL_INTX_LOGIN_PAGE_FR_CA,
          children: 'CONNEXION'
        }
        ,
        activate: {
          to: ROUTE_PATH_ACTIVATE,
          children: 'ACTIVER'
        }
      }
    }
  ]
};
